// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultauth: 'fackbackend',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  },
  backEndConfig:{
    baseApiUrl: 'https://air-mtt-be.transshipment.ai/api/',
    baseCsvUrl: 'https://air.microshipments.com:5000/',
    mapApi: 'AIzaSyDLE8whAcoz36hAANc4QvU1z2FiXz9zP_s',
    sessionKey: 'EncKey!123$#',
    baseUiUrl: 'https://www.air-mtt.transshipment.ai/'
  }
};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
